import { useTranslate } from '@repo/shared/hooks'
import { Button, Card, Col, Row, Typography } from '@repo/ui/components'
import { useSearchParams } from 'next/navigation'
import { useEffect, useState } from 'react'
import { QuickKycForm } from './quick-kyc.form'
import { QuickKycLoading } from './quick-kyc.loading'
import { useAgentAuthDetails } from '@repo/services'
import { useRouter } from '@repo/shared/i18n/navigation'
import { QuickKycExitDialog } from './quick-kyc.exit-dialog'
import { Cookie } from '@repo/tools'

export const QuickKycContainer = () => {
  const [isExitDialogOpen, setIsExitDialogOpen] = useState(false)
  const searchParams = useSearchParams()
  const mobileOrEmail = searchParams.get('mobileOrEmail') ?? ''

  const { t } = useTranslate()
  const { replace, push } = useRouter()

  const { data: authDetails, isLoading } = useAgentAuthDetails()
  const kyc = authDetails?.data?.details?.kyc

  // Check KYC status and redirect accordingly
  useEffect(() => {
    if (!isLoading && kyc) {
      const kycStatus = kyc.status
      if (kycStatus === 'approved') {
        Cookie.remove('kyc_required')
        Cookie.remove('kyc_mobile_or_email')
        replace('/dashboard')
      } else if (kycStatus === 'waiting_for_review') {
        Cookie.remove('kyc_required')
        Cookie.remove('kyc_mobile_or_email')
        replace('/auth/success')
      } else if (kycStatus === 'rejected') {
        Cookie.remove('kyc_required')
        Cookie.remove('kyc_mobile_or_email')
        replace('/auth/rejected')
      }
    }
  }, [kyc, isLoading, replace])

  // Show skeleton while loading or if KYC exists (will redirect)
  if (kyc || isLoading) {
    return <QuickKycLoading />
  }

  const handleCancelExit = () => {
    setIsExitDialogOpen(true)
  }

  const handleLogout = () => {
    // Clear session storage and redirect to login
    sessionStorage.removeItem('kyc_response')
    Cookie.removeAuthTokens()
    Cookie.remove('kyc_status')
    Cookie.remove('kyc_reason')
    push('/auth/register')
  }

  const handleReturnToVerification = () => {
    setIsExitDialogOpen(false)
    // Stay on current page to continue verification
  }

  const handleCloseExitDialog = () => {
    setIsExitDialogOpen(false)
  }

  return (
    <div className='px-md'>
      <Card className='p-xl rounded-sm'>
        <Col className='gap-3xl'>
          <Row className='justify-between'>
            <Typography size='2xl' weight='bold'>
              {t('quickKyc_title')}
            </Typography>
            <Row className='gap-xs w-fit'>
              <Button
                onClick={handleCancelExit}
                size='sm'
                variant='transparent'
              >
                {t('quickKyc_cancel_exit')}
              </Button>
            </Row>
          </Row>
          <QuickKycForm
            onSuccess={(mobileOrEmail, response) => {
              // Store entire response in sessionStorage for job-qualifications page
              sessionStorage.setItem('kyc_response', JSON.stringify(response))
              replace(`/auth/job-qualifications?mobileOrEmail=${mobileOrEmail}`)
            }}
            mobileOrEmail={mobileOrEmail}
          />
        </Col>
        <QuickKycExitDialog
          isOpen={isExitDialogOpen}
          onClose={handleCloseExitDialog}
          onLogout={handleLogout}
          onReturn={handleReturnToVerification}
        />
      </Card>
    </div>
  )
}
